import { ComponentProps, createContext } from 'react';

import { TEXT_VARIANTS } from '@pukka/common/constants';

import { Button } from '../../Button';

const SIZES = {
  md: {
    title: `px-5 py-4 ${TEXT_VARIANTS['title-1'].size}`,
    header: 'px-5 pt-5',
    body: 'my-5 max-h-60 px-5',
    footer: 'gap-x-2 py-4 px-5',
    button: 'm',
  },
  lg: {
    title: `px-8 py-4 ${TEXT_VARIANTS['heading-1'].size}`,
    header: 'px-8 pt-6',
    body: 'my-6 max-h-60 px-8',
    footer: 'gap-x-4 px-8 py-6',
    button: 'l',
  },
} satisfies Record<
  string,
  {
    title: string;
    header: string;
    body: string;
    footer: string;
    button: ComponentProps<typeof Button>['size'];
  }
>;

const ModalContext = createContext<{
  size: keyof typeof SIZES;
}>({
  size: 'md',
});

export { SIZES, ModalContext };
